// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2Zn29","image":"App_image__1-KX1"};